var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0772 6.26288C8.90518 6.26288 7.72992 7.48864 7.06744 8.57073C6.6839 9.21938 6.61417 9.86863 6.54443 10.4698H15.6099C15.5402 9.86863 15.4704 9.21938 15.0869 8.57073C14.4244 7.48864 13.2257 6.26288 11.0772 6.26288Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0348 12.2731H6.56946C6.7955 14.9164 8.54727 16.4812 11.6 16.4812C13.5874 16.4812 14.5108 15.5308 15.8706 14.5936L17.6314 15.5488C16.3064 16.7535 14.4591 18.5853 11.5302 18.5853C6.99749 18.5853 4.03377 15.6318 4.03377 11.4483C4.03377 7.62614 6.67587 4.3378 11.0343 4.3378C15.4624 4.3378 18.0348 7.6093 18.0348 11.1195V12.2731ZM19.2371 10.4696H22.1846C21.6129 4.45803 16.8781 0.500002 11.1214 0.500002C4.9794 0.500002 0 5.48421 0 11.6256C0 17.7683 4.9794 22.5 11.1214 22.5C16.8781 22.5 21.6129 18.2847 22.1846 12.2731H19.2371V10.4696Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyLogo);
export default __webpack_public_path__ + "static/media/tiny-logo.0e071d0b7e32965ac9bce3ea37810496.svg";
export { ForwardRef as ReactComponent };